function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.41176 6.005L11.7071 1.71321C12.0976 1.32305 12.0976 0.692789 11.7071 0.302626C11.3166 -0.0875365 10.6859 -0.0875365 10.2954 0.302626L6 4.59441L1.70463 0.292622C1.31414 -0.0975406 0.683354 -0.0975406 0.292866 0.292622C-0.097622 0.682784 -0.097622 1.31305 0.292866 1.70321L4.58824 6.005L0.292866 10.2968C-0.097622 10.687 -0.097622 11.3172 0.292866 11.7074C0.683354 12.0975 1.31414 12.0975 1.70463 11.7074L6 7.41559L10.2954 11.7074C10.6859 12.0975 11.3166 12.0975 11.7071 11.7074C12.0976 11.3172 12.0976 10.687 11.7071 10.2968L7.41176 6.005Z",
  fill: "#777777"
});

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.020e6b63.svg";
export { ForwardRef as ReactComponent };